export const tableUpdatesV2 = (state, data) => {
    console.log('tableUpdatesV2', data)
    if (!data || data.length === 0) return state
    const currentVisibleTableId = state?.table?._id
    if (!currentVisibleTableId) return state
    if (data) {
        const rows = [...state.rows]
        const filteredRows = [...state.filteredRows]
        data.forEach(cellUpdate => {
            const tableId = cellUpdate.tableId
            if (tableId === currentVisibleTableId) {
                if (cellUpdate.rowId) {
                    const row = rows.find(r => r._id === cellUpdate.rowId)
                    if (row) {
                        row[cellUpdate.cellId] = cellUpdate.value
                    }
                    const filteredRow = filteredRows.find(r => r._id === cellUpdate.rowId)
                    if (filteredRow) {
                        filteredRow[cellUpdate.cellId] = cellUpdate.value
                    }

                }
            }
        })
        return { ...state, rows: [...rows], filteredRows: [...filteredRows] }
    }
    return state

}